import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';
import { useOrg } from '../lib/org';
export function useInvoicePilot() {
  const {currentOrg}=useOrg();
  return useQuery({queryKey:['invoice-pilot',currentOrg?.id],queryFn:()=>api.get<{enabled:boolean}>('/manual-invoice-drafts/capability'),enabled:!!currentOrg,retry:false});
}
export function InvoicePilotLink(){const q=useInvoicePilot();return q.data?.enabled?<p className="mb-4"><Link className="text-brand-700 underline" to="/invoice-drafts">Invoice drafts</Link></p>:null;}
